const de = { 
    serviceCall: 'Dienstleister kann anrufen',
    heading_request: 'Wie lauten die Details Ihrer Stellenanfrage?',
    valid_question1:        'Irgendwelche anderen Details, die Sie für relevant halten?',
    valid_question2:        'Wenn Sie nicht genügend Informationen bereitstellen. Dies wirkt sich auf die Anzahl der Angebote aus, die Sie erhalten.',
    valid_question3:        'Sie sollten mindestens 100 Buchstaben eingeben.',
    image_question: 'Möchten Sie Bilder hinzufügen?',
    where_location: 'Wo ? (Ort des Arbeitsplatzes)',
    location_validation:        'Wir können Ihren Standort nicht verwenden. Bitte Stadt suchen oder manuell eingeben',
    userMyLocation: 'MEINEN STANDORT VERWENDEN',
    enterCity: 'Geben Sie Ihren Stadtnamen ein',
    when_job: 'Wann ? (Datum der Tätigkeit)',
    answer_question: 'Möchten Sie diese Fragen beantworten?',
    inputAnswer: 'Geben Sie hier Ihre Antwort ein...',
    enterPhone: 'Geben Sie Ihr Telefon ein',
    phoneDescription:        'Unsere Profis kontaktieren Sie schneller, wenn Sie „Dienstanbieter kann anrufen“ auswählen.',
    enterPhoneNumber: 'Trage deine Telefonnummer ein',
    sendRequest: 'ANFRAGE SENDEN',
    alert_image: 'Bitte laden Sie mindestens ein Bild hoch.',
    alert_description: 'Bitte Beschreibung eingeben.',
    alert_address: 'Bitte geben Sie Ihre Adresse ein.',
    alert_one_option: 'Bitte wählen Sie eine Option.',
    alert_pick_date: 'Bitte Abholtermin.',
    alert_answer: 'Bitte beantworten Sie die Frage',
    alert_phone: 'Bitte Telefonnummer eingeben.',
    request_success_msg:        'Glückwunsch! Sie haben erfolgreich angefordert!',
    alert_close_description:        'Sie können kostenlose Angebote erhalten, indem Sie einige weitere Fragen beantworten.',
    go_on: 'MACH WEITER',
    quit: 'VERLASSEN',
    servicesCompanyReady: "Dienstleistungsunternehmen bereit",
    allow_contacts: "Meine Telefonnummer anzeigen",
    dont_disturbme: "Stör mich nicht",
    only_phone: "Kontaktieren Sie mich nur telefonisch",
    only_offers: "Senden Sie mir nur Angebote",
    only_whatsapp: "Kontaktieren Sie mich nur per WhatsApp",


    kEmailNullError: "Bitte geben Sie ihre E-Mail-Adresse ein",
    kInvalidEmailError:
        "Bitte eine gültige E-Mail-Adresse eintragen",
    kPassNullError: "Bitte geben Sie Ihr Passwort ein",
    kConfirmPasswordError: "Nicht übereinstimmendes Passwort",
    kShortPassError: "Passwort ist zu kurz, mindestens 8 Zeichen",
    kMatchPassError: "Passwörter stimmen nicht überein",
    kNameNullError: "Bitte tragen Sie Ihren vollen Namen ein",
    kPhoneNumberNullError: "Bitte gib deine Telefonnummer ein",


    email: 'Email',
    password: 'Passwort',
    pleaseendteryouremail: 'Bitte gib deine E-mail-Addresse ein',
    pleaseenteryourpassword: 'Bitte gib dein Passwort ein',

    confirmpassword: 'Neues Passwort bestätigen',


    name: 'Name',

    Congratulation: 'Glückwunsch',
    requestPriority: 'Priorität anfordern',


    free: 'Frei',
    high: "hoch",

    noSearchResult: 'Kein Suchergebnis',
    inputThree: 'Bitte geben Sie mindestens 3 Buchstaben ein',


    selected_city: 'Ausgewählte Stadt(en)',

    specificTime: 'Bestimmte Zeit (innerhalb von drei Wochen)',
    inTwoMonth: 'In zwei Monaten',
    inSixMonth: 'In sechs Monaten',
    onlyPrice: 'Suche nur nach Preis',
    flexibleTime: 'Flexibel',

    asap: 'So bald wie möglich',

    lab_continue: 'Weiter',


//CUSTOM
mainheading: 'Welche Art von Dienstleistungen suchen Sie?',
back: 'Zurück',
serviceErrHead: 'Leerer Dienst',
serviceError: 'Bitte wählen Sie einen Dienst aus, den Sie suchen, um fortzufahren.',

requiredField: "Pflichtfeld",
requireDesc: 'Das Feld ist obligatorisch.'



}

export default de;